import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import FuelModal from '../../../containers/masters/fuel/FuelModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class Fuel extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchName: null,
        searchDescription: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchFuelList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchFuelList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchFuelList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleDescriptionChange (searchDescription) {
    if (this.state.filter.searchDescription !== searchDescription) {
      this.setState({ filter: { ...this.state.filter, searchDescription } })
    }
  }

  searchFuel () {
    this.props.actions.fetchFuelList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchName: null,
        searchDescription: null
      }
    }, () => { this.searchFuel() })
  }

  render () {
    const {
      t, fuelList, pagesCount, fuelCount, filter,
      filter: { page },
      actions: { openEditFuelModal, fetchFuelList, deleteFuel, recoverFuel }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'fuelPage' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchDescription || this.state.filter.searchName)

    return (
      <div id="fuelMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openEditFuelModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}FUEL_MASTERS.NAME`)}
                placeholder={t(`${tKey}FUEL_MASTERS.NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.description"
                controlLabel={t(`${tKey}FUEL_MASTERS.DESCRIPTION`)}
                placeholder={t(`${tKey}FUEL_MASTERS.DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchFuel()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('name') }}>
                      {t(`${tKey}FUEL_MASTERS.NAME`)}
                      <i className={this.getSortIcon('name')} />
                    </th>
                    <th onClick={() => { this.changeOrder('description') }}>
                      {t(`${tKey}FUEL_MASTERS.DESCRIPTION`)}
                      <i className={this.getSortIcon('description')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {fuelList && fuelList.map((fuel, idx) => (
                    <tr key={idx} className={fuel.isDeleted ? 'is-deleted' : ''}>
                      <td>{fuel.name}</td>
                      <td>{fuel.description}</td>
                      <td className='actions'>
                        {!fuel.isDeleted ? (
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openEditFuelModal(fuel.fuelId)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => deleteFuel(fuel.fuelId)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          <div>
                            <OverlayTrigger placement="left" overlay={recoverTooltip}>
                              <a className='_Btn accent stk o-icn ' onClick={() => recoverFuel(fuel.fuelId)}>
                                <i className="iDocIcon-undo-back"></i>
                              </a>
                            </OverlayTrigger>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                  }
                </tbody>
              </Table>
              {(fuelList === null || fuelList === undefined || fuelList.length === 0) &&
              <p className="no_results" >{t(`${tKey}FUEL_MASTERS.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={fuelCount}
                    onSelectAction={(value) => fetchFuelList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <FuelModal/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listFuel'
})(Fuel)
